import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { StyledFab } from './ScrollToTopButton.styled';
import { ScrollToTopButtonProps } from './ScrollToTopButton.types';

export const ScrollToTopButton = ({ onClick }: ScrollToTopButtonProps) => {
  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    onClick?.();
  };

  return (
    <StyledFab size='small' color='primary' aria-label='scroll to top' onClick={handleClick}>
      <ArrowUpwardIcon />
    </StyledFab>
  );
};
